import { getAPI,postAPI} from "../../api/api";
import { REACT_APP_MESSAGING } from "../../utils/common";



export async function getAllNotifications(loginId: string) {
    const Details = getAPI( REACT_APP_MESSAGING + `/message-list/${loginId}`)
    return Details
}

export async function updateNotificationStatus(notificationId: string) {
    let value = {
        "notificationId":notificationId,
        "status":false
      };
    const Details = postAPI( REACT_APP_MESSAGING + `/message-status`,value)
    return Details
}